import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Package } from '../models/package';
import { Page } from '../interfaces/page';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { combineLatest, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { PackageQuery } from '../models/package-query';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PackageService extends EntityCollectionServiceBase<Package> {

    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, private http: HttpClient) {
        super('Package', serviceElementsFactory);
    }

    get(id: string): Observable<Package> {
        return this.entityMap$.pipe(
            map((entities) => entities[id]),
            switchMap((value) => value ? of(value) : this.getByKey(id))
        );
    }

    getMultiple(ids: string[]): Observable<Package[]> {
        return combineLatest(ids.map(id => this.get(id)));
    }

    query(query: PackageQuery): Observable<Page<Package>> {
        let params = new HttpParams()
            .set('page', query.pageNumber?.toString() || 1)
            .set('itemsPerPage', query.itemsPerPage?.toString() || 25);
        if (query.sortColumn) {
            params = params.set('order[' + query.sortColumn + ']', query.sortDescending ? 'DESC' : 'ASC');
        }
        if (query.description) {
            params = params.set('description', query.description);
        }
        if (query.packagingType) {
            params = params.set('packagingType', query.packagingType);
        }
        const headers = new HttpHeaders({ Accept: 'application/ld+json' });
        return this.http.get<Page<Package>>(`${environment.apiUrl}/package`, { headers, params }).pipe(
            map(response => ({ totalCount: response['hydra:totalItems'], page: response['hydra:member']}))
        );
    }

}
